export const YEAR_FULL_FORMAT = 'yyyy';
export const MONTH_NUM_FORMAT = 'MM';
